module.exports = __webpack_public_path__ + "img/16.16355f10.jpg";